import React from "react"
import PropTypes from "prop-types"
import { FormattedMessage } from "react-intl"
import { WingsDetailText, WingsLink } from "@wingspans-ui"
import { publicPageGroups } from "../home-page/publicPages"

/**
 * Panel of public page links shown beneath the header on small screens, opened by the hamburger button.
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {Function} props.onNavigate called when a link is clicked so the panel can close
 * @returns {JSX}
 */
const PublicHeaderMobileMenu = ({ isOpen, onNavigate }) => (
  <nav
    id="public-header-mobile-menu"
    className={`public-header-mobile-menu w-p-2${isOpen ? " public-header-mobile-menu--open" : ""}`}
    inert={isOpen ? undefined : "true"}
  >
    {publicPageGroups.map((group) =>
      group.pages ? (
        <div key={group.key} className="w-flex w-flex-column w-gap-1">
          <WingsDetailText className="w-font-bold">
            <FormattedMessage {...group.titleMessage} />
          </WingsDetailText>
          {group.pages.map((page) => (
            <WingsLink key={page.key} to={page.path} size="detail" className="public-header-nav-link" onClick={onNavigate}>
              <FormattedMessage {...page.titleMessage} />
            </WingsLink>
          ))}
        </div>
      ) : (
        <WingsLink key={group.key} to={group.path} size="detail" className="public-header-nav-link" onClick={onNavigate}>
          <FormattedMessage {...group.titleMessage} />
        </WingsLink>
      )
    )}
  </nav>
)

PublicHeaderMobileMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onNavigate: PropTypes.func.isRequired,
}

export default PublicHeaderMobileMenu
